<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<h2 class="title">Reminder</h2>

								<div class="row border border-secondary rounded p-15">
									<div class="col-12 col-md row" v-for="reminder in reminderCheck" style="font-size:15px;">
										<div class="col-md-4">
											<i class="fa fa-lg" :class="{'fa-check-circle green' : reminder.value , 'fa-times-circle red' : !reminder.value}"></i>
										</div>
										<div class="col-md-8">
											{{reminder.category}} {{reminder.notes ? `(${reminder.notes})` : ''}}
										</div>
									</div>
								</div>

								<h4 class="mt-3">Konfirmasi Harga Penagihan Asuransi : Rp. {{total}}</h4>

								<!-- <button></button> -->
								<div class="row mt-3">
									<div class="col-6 col-md-3 offset-md-3">
										<button class="w-100 btn btn-primary" @click="$emit('submitForm')">Saya Ingin Tagih Yang Tersangkut</button>
									</div>
									<div class="col-6 col-md-3">
										<button class="w-100 btn btn-danger" @click="$emit('closeModal')">Saya Ingin Check Ulang</button>
									</div>
								</div>

								<!-- {{estimations}} -->
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div> -->
			</div>
		</div>
	</transition>
</template>

<script>
import MultiSelect from "vue-multiselect";
import Terbilang from "terbilang-js";
import moment from "moment";

export default {
	data() {
		return {
			moment: moment,
			data: null,
			reminderCheck : [{
				category : 'Gambar Epoxy Lengkap',
				value : true,
				notes : ''
			},{
				category : 'Foto Selesai',
				value : true
			},{
				category : 'Sparepart Komplit',
				value : true,
				notes : ''
			}]
		};
	},
	props: ["workorder" , 'total' , 'woProgress' , 'listPayment' , 'estimations'],
	components: {
		MultiSelect,
	},
	async mounted() {
		this.loadData();
		// Check Gambar Epoxy
		// console.log(this.woProgress)
		let keys = Object.keys(this.woProgress)

		let epoxyTotal = keys.length
		let epoxyDone = 0

		for(var i in keys) {
			if(!this.woProgress[keys[i]])
				this.reminderCheck[0].value = false

			if(this.woProgress[keys[i]])
				epoxyDone++;
		}

		this.reminderCheck[0].notes = `${epoxyDone}/${epoxyTotal}`

		// Check Sparepart Datang
		let sparepartTotal = this.estimations.length
		let sparepartArrived = 0
		if(this.estimations.length > 0) {
			sparepartArrived = this.estimations.filter( x=> x.is_arrived).length;
			this.reminderCheck[2].value = this.estimations.filter(x => !x.is_arrived).length > 0 ? false : true
		}

		

		this.reminderCheck[2].notes = `${sparepartArrived}/${sparepartTotal}`


	},
	watch: {},
	methods: {
		printPage() {
			this.$htmlToPaper("printMe");
		},
		loadData() {
			this.$http
				.get(
					"/api/v1/workorder-estimation/payment-statement/" +
						this.workorder
				)
				.then((resp) => {
					this.data = resp.data.data;
					console.log(this.data);
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style scoped>
td {
	font-size: 12px;
}

/* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

.companyDetails {
	margin-bottom: 5px;
	font-size: 0.6rem;
}
/* .documentTitle{
    font-size: 40px;
    border: 1px solid black;
    border-radius: 10px;
    padding:20px 30px;
  } */
.contentTitle {
	margin-top: 8px;
	font-size: 14px;
	font-weight: 700;
}
.contentVariable {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 14px;
}

.green {
	color :green;
}

.red {
	color : red;
}
</style>
